import {Injectable} from '@angular/core';
import {HttpService, QueryModel} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {ReserveModel} from '../../models/reserve/reserve.model';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {PatientModel} from '../../models/patient/patient.model';
import {AppointmentModel, ReservedAppointmentsModel} from '../../models/appointment/appointment.model';
import {PatientFileModel} from '../../models/patient-file/patient-file.model';
import {AppointmentConfirmModel} from '../../models/appointment-confirm/appointment-confirm.model';

@Injectable({
    providedIn: 'root'
})
export class PatientService extends HttpService {

    reserveAppointment(patientId: string, reserveModel: ReserveModel): Observable<any> {
        return this.post(`patients/${patientId}/appointments/reserve`, reserveModel).pipe(
            map((response: any) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    cancelReservation(patientId: string, appointmentId: string): Observable<any> {
        return this.delete(`patients/${patientId}/appointments/${appointmentId}/cancel-reservation`).pipe(
            map((response: any) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    confirmAppointment(patientId: string, appointmentId: string, confirmModel: AppointmentConfirmModel): Observable<any> {
        return this.put(`patients/${patientId}/appointments/${appointmentId}/confirm`, confirmModel).pipe(
            map((response: any) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    getPatientAppointments(patientId: string, query?: QueryModel): Observable<iResponseList<ReservedAppointmentsModel>> {
        return this.get(`patients/${patientId}/appointments`, query).pipe(
            map((response: iResponseList<ReservedAppointmentsModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    getMe(): Observable<iResponse<PatientModel>> {
        return this.get('patients/me').pipe(
            map((response: iResponse<PatientModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    updateMe(patientModel: PatientModel): Observable<iResponse<PatientModel>> {
        return this.put('patients/me', patientModel).pipe(
            map((response: iResponse<PatientModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    getPatientFiles(patientId: string, query?: QueryModel): Observable<iResponseList<PatientFileModel>> {
        return this.get(`patients/${patientId}/patient-files`, query).pipe(
            map((response: iResponseList<PatientFileModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    updatePatientFiles(patientId: string, patientFileModel: PatientFileModel): Observable<iResponse<PatientFileModel>> {
        return this.put(`patients/${patientId}/patient-files/${patientFileModel.id}`, patientFileModel).pipe(
            map((response: iResponse<PatientFileModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    getPatientsForDoctorId(doctorId: string): Observable<iResponseList<PatientModel>> {
        const query: QueryModel = {
            doctorId : doctorId
        }
        return this.get(`patients`, query).pipe(
            map((response: iResponseList<PatientModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }
}
